<script setup>
import { ref, computed, onMounted } from 'vue';
import {router, useForm, usePage} from '@inertiajs/vue3';
import LanguageModal from '@/Components/LanguageModal.vue';
import SvgIcon from '@/Components/SvgIcon.vue';
import TextInput from '@/Components/TextInput.vue';
import {useI18n} from "vue-i18n";

// Show modal state
const show = ref(false);

// Define the default language and languages array
const { props } = usePage();
const language = ref(props.locale);
const langs = ref(props.locales);

const {locale} = useI18n({useScope: 'global'});
locale.value = usePage().props?.locale ?? 'en';

// Function to update language based on radio button selection
// Function to update language based on radio button selection
const currentRoute = ref(route().current());
const updateLanguage = (code) => {
    if (language.value !== code) {
        language.value = code;
        localStorage.setItem('language', code);

        useForm(
            { locale: code, currentRoute: currentRoute.value }
        ).post(route('locale'), { onSuccess: () => location.reload() });
    }
};

// Computed property to find the current language
const currentLanguage = computed(() => {
    return langs.value.find(lang => lang.code === language.value);
});

function trimString(str) {
    return str.slice(0, 2);
}

// Search term for filtering languages
const searchTerm = ref('');

// Computed property to filter languages by search term
const filterByTerm = computed(() => {
    const term = searchTerm.value.toLowerCase();
    return langs.value.filter(lang => {
        return (
            lang.title.toLowerCase().includes(term) ||
            lang.nativeTitle.toLowerCase().includes(term)
        );
    });
});
</script>

<template>
    <button class="px-6 md:px-3 py-2.5 flex items-center gap-2 text-white text-base rounded-full hover:bg-block-overlay-light transition ease-out duration-300" :class="{'bg-block-overlay': props.auth.user !== null}" @click="show = true">
        <SvgIcon name="global" width="24" height="24" />
        <span class="uppercase">{{ trimString(currentLanguage.code) }}</span>
        <SvgIcon name="dropdown" width="9" height="9" class="text-grayscale-600 rotate-180 ml-auto" />
    </button>
    <LanguageModal v-model="show" :title="$t('global.langTitle')">
        <button class="text-grayscale-600 hover:text-white absolute top-5 right-5 cursor-pointer" @click="show = false">
            <SvgIcon name="close" width="32" height="32" />
        </button>
        <!-- <div class="relative">
            <TextInput v-model="searchTerm" type="text" placeholder="Search languages" class="block w-full pr-12" />
            <div class="absolute top-[14px] right-[14px] text-grayscale-600">
                <SvgIcon name="magnifer" width="24" height="24" />
            </div>
        </div> -->
        <div class="flex flex-col sm:gap-4">
            <div v-for="lang in filterByTerm" :key="lang.code">
                <input type="radio" :id="'lang_' + lang.code" name="language" :value="lang.code" @change="updateLanguage(lang.code)" class="sr-only peer" :checked="language === lang.code" />
                <label :for="'lang_' + lang.code" class="flex items-center gap-3 max-sm:py-4 text-white cursor-pointer relative before:content-[''] before:block before:w-5 before:h-5 before:rounded-full before:bg-grayscale-800 before:border before:border-solid before:border-grayscale-700 hover:before:border-grayscale-600 peer-checked:before:bg-primary-500 after:content-[''] after:block after:bg-transparent after:absolute after:top-[calc(50% - 3px)] after:left-[7px] after:w-1.5 after:h-1.5 after:rounded-full peer-checked:after:bg-grayscale-800">
                    <span class="text-lg text-nowrap">{{ lang.title }} <span class="text-grayscale-600">{{ lang.nativeTitle }}</span></span>
                </label>
            </div>
        </div>
    </LanguageModal>
</template>

<style scoped></style>
